import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { ControllerService } from '../shared/services/controller.service';

@Injectable()
export class AuthGuardSuper implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


      if (this.authService.isSuper()) {

        return true
      }

      this.router.navigate(['/signin']);

      return false
  }
}
